
import { Component, Mixins } from "vue-property-decorator";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import PazToast from "@pazion/pazion-core/src/components/utils/PazToast.vue";
import PazConfirmation from "@pazion/pazion-core/src/components/utils/PazConfirmation.vue";
import PazRefreshButton from "@pazion/pazion-core/src/components/controls/PazRefreshButton.vue";
import ContractListingMixin from "@pazion/pazion-catalog/src/views/contracts/mixins/contracts-listing.mixin";
import ContractDetailsModal from "@pazion/pazion-catalog/src/views/contracts/contract-details/ContractDetailsModal.vue";
import FileUploader from "@pazion/pazion-core/src/components/common/FileUploader.vue";
import {extractDate} from "@pazion/pazion-catalog/src/helpers/format";
import PermissionService from "@pazion/pazion-core/src/services/permission-service";

@Component({
  methods: {extractDate},
  components: {
    PazTooltipButton,
    PazToast,
    FileUploader,
    PazRefreshButton,
    PazConfirmation,
    ContractDetailsModal,
  },
})
export default class ContractListing extends Mixins(ContractListingMixin, PermissionService) {
  refs!: {
    toast: PazToast;
    confirm: PazConfirmation;
  };
  get showUploadButton(){
      return this.userHasFlag('contractManagement.uploadPrinterFile');
  }
} //
